import { DvToolbarAction, DvToolbarActionEvent } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { TranslateService } from '@ngx-translate/core';
import UserUtils from '@shared/utils/user.utils';
import { ColDef } from 'ag-grid-community';
import { UserRoleDto } from '@pages/users-page/components/user-access-control-tab/interfaces';

@Injectable()
export class UserRoleGridService {
  private translate = inject(TranslateService);

  readonly colDefs: ColDef<UserRoleDto>[] = [
    {
      headerName: 'Grid.UserRoleId',
      field: 'UserRoleID',
      type: [ColumnType.Id],
      hide: true,
    },
    {
      headerName: 'Grid.id',
      field: 'RoleID',
      type: [ColumnType.Id],
      hide: true,
    },
    {
      filter: 'agTextColumnFilter',
      field: 'Name',
      valueGetter: ({ colDef, data }) =>
        UserUtils.translationValueGetter(colDef, 'Name', data!, this.translate),
      headerName: 'RolesGrid.RoleName',
      type: [ColumnType.Text],
      width: 350,
      enableRowGroup: false,
    },
    {
      filter: 'agTextColumnFilter',
      field: 'RoleDescription',
      valueGetter: ({ colDef, data }) =>
        UserUtils.translationValueGetter(
          colDef,
          'Description',
          data!,
          this.translate
        ),
      headerName: 'RolesGrid.RoleDescription',
      type: [ColumnType.Text],
      flex: 1,
      enableRowGroup: false,
    },
    {
      field: 'TranslationKey',
      type: [ColumnType.Text],
      hide: true,
      suppressColumnsToolPanel: true,
    },
  ];

  getToolbarActions(
    addFn: () => void,
    deleteFn: (event: DvToolbarActionEvent) => void
  ): DvToolbarAction[] {
    return [
      {
        icon: 'delete',
        clickFn: (event: DvToolbarActionEvent) => deleteFn(event),
        disabled: true,
        tooltipKey: 'Grid.Delete',
      },
      {
        icon: 'add_box',
        clickFn: addFn,
        disabled: false,
        tooltipKey: 'Grid.Add',
      },
    ];
  }
}
